import ApiService from '@/services/api'
import { defineStore } from 'pinia'

const ENDPOINT = '/teams/'
const ITEM_ID  = 'tem_id'

export const useTeamStore = defineStore('teams', {
  state: () => ({
    item: { tem_customfields: {}, tem_sta_id: 'GEN01', _pivot: { users: [], equipments: [], drawings: [], layers: [] } },
    itemList: [],
    metaItems: null
  }),
  getters: {},
  actions: {
    fetchItem (id, options) {
      return new Promise((resolve, reject) => {
        options = (options) ? '/' + options : ''
        if (id && id > 0) {
          ApiService.get(ENDPOINT + id + options).then((response) => {
            if (!response.data.data.tem_customfields || Object.prototype.toString.call(response.data.data.tem_customfields) === '[object Array]') {
              response.data.data.tem_customfields = {}
            }
            this.SET_ITEM(response.data.data)
            resolve(this.item)
          }).catch((error) => { reject(error) })
        } else {
          this.RESET_ITEM()
          resolve(this.item)
        }
      })
    },
    fetchItems (options) {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + (options || '')).then((response) => {
          this.metaItems = response.data.meta
          if (Object.prototype.toString.call(response.data.data) === '[object Array]') {
            this.SET_ITEMS(response.data.data)
          }
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    storeItem () {
      return new Promise((resolve, reject) => {
        ApiService.post(ENDPOINT, this.item).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    updateItem () {
      return new Promise((resolve, reject) => {
        ApiService.put(ENDPOINT + this.item[ITEM_ID], this.item).then((response) => {
          this.SET_ITEM(response.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    destroyItem (id) {
      return new Promise((resolve, reject) => {
        this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
        ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then(() => {
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    // Récupère les utilisateurs par défaut (membres d'équipe du user courant)
    fetchDefaultUsers () {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + 'default-users').then((response) => {
          resolve(response.data.data || response.data)
        }).catch((error) => { reject(error) })
      })
    },
    // Affecte un chef d'équipe / une équipe à un drawing
    assignDrawingLeader (draId, data) {
      return new Promise((resolve, reject) => {
        ApiService.put(ENDPOINT + 'drawing/' + draId + '/leader', data).then((response) => {
          resolve(response.data)
        }).catch((error) => { reject(error) })
      })
    },
    // Récupère le drawing (secteur) lié à une card via dra_cad_uid, avec son chef d'équipe
    fetchCardDrawingLeader (cadUid) {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + 'card/' + cadUid + '/leader').then((response) => {
          resolve(response.data.data)
        }).catch((error) => { reject(error) })
      })
    },
    // Affecte un chef d'équipe / une équipe au drawing lié à une card via dra_cad_uid
    updateCardDrawingLeader (cadUid, data) {
      return new Promise((resolve, reject) => {
        ApiService.put(ENDPOINT + 'card/' + cadUid + '/leader', data).then((response) => {
          resolve(response.data.data)
        }).catch((error) => { reject(error) })
      })
    },
    // Récupère les objets dans le polygone d'un drawing
    fetchDrawingObjects (draId) {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + 'drawing/' + draId + '/objects').then((response) => {
          resolve(response.data.data)
        }).catch((error) => { reject(error) })
      })
    },
    // Récupère tous les objets visibles par une équipe (drawings + layers, ou tout si aucun)
    fetchTeamVisibleObjects (temId) {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + temId + '/visible-objects').then((response) => {
          resolve(response.data.data)
        }).catch((error) => { reject(error) })
      })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) {
      this.item = item
      if (this.item && (!this.item.tem_customfields || Object.prototype.toString.call(this.item.tem_customfields) === '[object Array]')) {
        this.item.tem_customfields = {}
      }
      this.item._pivot = {}
      this.item._pivot['users']      = (this.item.users) ? [...this.item.users.map(a => a['id'])] : []
      this.item._pivot['equipments'] = (this.item.equipments) ? [...this.item.equipments.map(a => a['equ_id'])] : []
      this.item._pivot['drawings']   = (this.item.drawings) ? [...this.item.drawings.map(a => a['dra_id'])] : []
      this.item._pivot['layers']     = (this.item.layers) ? [...this.item.layers.map(a => a['lra_id'])] : []
    },
    SET_ITEMS (itemList) {
      itemList.forEach(element => {
        element.tem_customfields = (!element.tem_customfields) ? {} : element.tem_customfields
      })
      this.itemList = itemList
    },
    RESET_ITEM () { this.item = { tem_customfields: {}, tem_sta_id: 'GEN01', _pivot: { users: [], equipments: [], drawings: [], layers: [] } } }
  }
})
